<template>
  <section class="bg-primary-500 py-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

      <div class="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
        <div
          v-for="(stat, index) in stats"
          :key="stat.label"
          class="text-center"
          :class="index < stats.length - 1 ? 'lg:border-r lg:border-primary-400' : ''"
        >
          <!-- Number -->
          <div class="text-5xl lg:text-[60px] font-extrabold text-white leading-none mb-2">
            {{ stat.value }}
          </div>
          <!-- Label -->
          <div class="text-primary-100 text-sm font-medium uppercase tracking-wide">
            {{ stat.label }}
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

interface Stat {
  value: string
  label: string
}

@Options({
  data () {
    return {
      stats: [
        { value: '99%', label: 'Happy Customers' },
        { value: '780K', label: 'Property Sales' },
        { value: '160+', label: 'Award Winning' },
        { value: '33', label: 'Years Experience' }
      ] as Stat[]
    }
  }
})
export default class StatsSection extends Vue {}
</script>
